import { Injectable } from '@angular/core';
import { NetworkManager } from 'src/app/managers/network/network.manager';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { RequestField } from 'src/app/enums/network/request/requestField.enum';
import { StatisticRequestBean } from 'src/app/beans/request/statistic-request.bean';
import { StatsApi } from 'src/app/enums/network/request/stats/stats.api';

@Injectable({
  providedIn: 'root',
})
export class StatisticRequest {
  constructor(private network: NetworkManager) {}

  get(token: string, data: StatisticRequestBean) {
    const url = this.network.StatsApi() + StatsApi.STATISTIC;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    let params = new HttpParams();

    if (data.period) params = params.set(RequestField.PERIOD, data.period.toString());

    if (data.level) params = params.set(RequestField.LEVEL, data.level.toString());

    if (data.levelid || data.levelid == 0)
      params = params.set(RequestField.LEVEL_ID, data.levelid.toString());

    if (data.sc) params = params.set(RequestField.SERVICE_COUNTER, data.sc.toString());

    if (data.scid)
      params = params.set(RequestField.SERVICE_COUNTER_ID, data.scid.toString());

    if (data.dt) params = params.set(RequestField.DETAIL_TOTAL, data.dt.toString());

    if (data.datefrom)
      params = params.set(RequestField.DATE_FROM, data.datefrom.toString());

    if (data.dateto) params = params.set(RequestField.DATE_TO, data.dateto.toString());

    return this.network.http().get(url, { headers, params });
  }

  excel(token: string, data: StatisticRequestBean) {
    const url = this.network.StatsApi() + StatsApi.STATISTIC_EXCEL;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    let params = new HttpParams();

    if (data.level) params = params.set(RequestField.LEVEL, data.level.toString());

    if (data.levelid) params = params.set(RequestField.LEVEL_ID, data.levelid.toString());

    if (data.sc) params = params.set(RequestField.SERVICE_COUNTER, data.sc.toString());

    if (data.scid)
      params = params.set(RequestField.SERVICE_COUNTER_ID, data.scid.toString());

    if (data.datefrom)
      params = params.set(RequestField.DATE_FROM, data.datefrom.toString());

    if (data.dateto) params = params.set(RequestField.DATE_TO, data.dateto.toString());

    return this.network.http().get(url, { headers, params, responseType: 'arraybuffer' });
  }
}
